import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.css';

const CustomDropdown = ({ options, value, onChange, placeholder, preserveOrder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter(opt => {
    const optStr = typeof opt === 'string' ? opt : String(opt);
    return optStr.toLowerCase().includes(searchTerm.toLowerCase());
  });
  const displayOptions = preserveOrder ? filteredOptions : [...filteredOptions].sort((a, b) => {
    const aStr = typeof a === 'string' ? a : String(a);
    const bStr = typeof b === 'string' ? b : String(b);
    return aStr.localeCompare(bStr);
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="custom-dropdown-control" onClick={() => setIsOpen(!isOpen)}>
        {value || placeholder}
        <span className="custom-dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="custom-dropdown-menu">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search..."
            autoFocus
            className="custom-dropdown-search"
          />
          <div className="custom-dropdown-options">
            {displayOptions.length > 0 ? (
              displayOptions.map((option) => (
                <div
                  key={option.toString()}
                  className="custom-dropdown-option"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.toString()}
                </div>
              ))
            ) : (
              <div className="custom-dropdown-no-options">No options found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown; 